'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// Dependencies: jQuery
var $ = jQuery;

var Nav = function () {
	function Nav(_ref) {
		var _this = this;

		var source_id = _ref.source_id,
		    target_id = _ref.target_id,
		    target_wrapper_id = _ref.target_wrapper_id,
		    toggle_class = _ref.toggle_class,
		    _ref$desktop_style = _ref.desktop_style,
		    desktop_style = _ref$desktop_style === undefined ? 'dropdown' : _ref$desktop_style,
		    _ref$breakpoint = _ref.breakpoint,
		    breakpoint = _ref$breakpoint === undefined ? 992 : _ref$breakpoint,
		    default_thumbnail = _ref.default_thumbnail;

		_classCallCheck(this, Nav);

		this.menu_id = '#' + source_id;
		this.desktop_menu_wrapper = $('#' + target_wrapper_id);
		this.stage_toggles = $('.' + toggle_class);
		this.desktop_menu_id = target_id;
		this.breakpoint = breakpoint;
		this.desktop_style = desktop_style;
		this.unstaged = false;
		this.default_thumbnail = default_thumbnail;

		this.handleUnstage();
		$(window).on('resize', function () {
			return _this.handleUnstage();
		});
	}

	_createClass(Nav, [{
		key: 'handleUnstage',
		value: function handleUnstage() {
			if (!this.unstaged && window.matchMedia('(min-width: ' + this.breakpoint + 'px)').matches) {
				/* the viewport is at least breakpoint pixels wide */
				this.unstaged = true;
				this.stage_toggles.attr('style', 'display: none !important;');

				if (!this.desktop_menu) {
					this.desktop_menu = $(this.menu_id).clone().appendTo(this.desktop_menu_wrapper).attr('id', this.desktop_menu_id).addClass(this.desktop_menu_id + '-' + this.desktop_style);

					switch (this.desktop_style) {
						case 'thumbnails':
							if (!this.default_thumbnail) console.error('A default_thumbnail URL is required for a menu with desktop_style of thumbnails.');
							this.convertCollapseToThumbnails(this.desktop_menu_wrapper);
							break;
						case 'dropdown':
							this.convertCollapseToDropdown(this.desktop_menu_wrapper);
							break;
						default:
							break;
					}
				} else {
					this.desktop_menu.show();
				}
			} else if (this.unstaged && !window.matchMedia('(min-width: ' + this.breakpoint + 'px)').matches) {
				/* the viewport is less than breakpoint pixels wide*/
				this.unstaged = false;
				this.stage_toggles.show();
				this.desktop_menu.hide();
			}
		}
	}, {
		key: 'convertCollapseToThumbnails',
		value: function convertCollapseToThumbnails(wrapper) {
			var collapse_toggles = $(wrapper).find('[data-toggle="collapse"]');
			$(wrapper).find('.collapse-wrapper').addClass('thumbnail-dropdown-wrapper').removeClass('collapse-wrapper');
			$(wrapper).find('#' + this.desktop_menu_id).removeClass('nav-bordered nav-stacked flex-column').addClass('flex-row');
			collapse_toggles.closest('li').find('> a').attr('data-toggle', '');
			collapse_toggles.remove();
			$(wrapper).find('.collapse').addClass('thumbnail-dropdown-menu').removeClass('collapse');

			var toggles = $(wrapper).find('.thumbnail-dropdown-wrapper');
			var menu_thumbnail_items = $(wrapper).find('.thumbnail-dropdown-menu').find('a');

			var _iteratorNormalCompletion = true;
			var _didIteratorError = false;
			var _iteratorError = undefined;

			try {
				for (var _iterator = menu_thumbnail_items[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
					var menu_thumbnail_item = _step.value;

					var thumbnail_url = $(menu_thumbnail_item).attr('data-thumbnail') ? $(menu_thumbnail_item).attr('data-thumbnail') : this.default_thumbnail;
					var text = $(menu_thumbnail_item).text();
					var html = '\n\t\t\t\t<div class="thumbnail-dropdown-item-image">\n\t\t\t\t\t<img src="' + thumbnail_url + '" alt="' + text + '">\n\t\t\t\t</div>\n\t\t\t\t<div class="thumbnail-dropdown-item-text">\n\t\t\t\t\t' + text + '\n\t\t\t\t</div>\n\t\t\t';
					$(menu_thumbnail_item).addClass('thumbnail-dropdown-item').html(html);
				}
			} catch (err) {
				_didIteratorError = true;
				_iteratorError = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion && _iterator.return) {
						_iterator.return();
					}
				} finally {
					if (_didIteratorError) {
						throw _iteratorError;
					}
				}
			}
		}
	}, {
		key: 'convertCollapseToDropdown',
		value: function convertCollapseToDropdown(wrapper) {
			var collapse_toggles = $(wrapper).find('[data-toggle="collapse"]');
			$(wrapper).find('.collapse-wrapper').addClass('dropdown').removeClass('collapse-wrapper');
			$(wrapper).find('.collapse').addClass('dropdown-menu').removeClass('collapse');
			$(wrapper).find('.dropdown-menu').find('> .menu-item').addClass('dropdown-item');
			$('#menu-header-desktop').find('a').on('click', function () {
				document.location = $(this).attr('href');
			});
			$(wrapper).find('#' + this.desktop_menu_id).removeClass('nav-bordered nav-stacked flex-column').addClass('flex-row');
			collapse_toggles.closest('li').find('> a').attr('data-toggle', 'dropdown').addClass('dropdown-toggle');
			collapse_toggles.remove();

			var $menus = $(wrapper).find('.dropdown-menu');
			if ($menus.length > 0) {
				$menus.dropdown();

				for (var i = 0; i <= $menus.length; i++) {
					var menu = $menus[i];
					if (menu) {
						var $menu = $(menu);

						// Add parent item before menu
						var $parent_link = $menu.closest('li').find('> a').clone().addClass('parent-link').removeClass('dropdown-toggle').removeAttr('data-toggle');

						if ($parent_link.length > 0) {
							$menu.prepend('<li>\n\t\t\t\t\t\t\t<a href="' + $parent_link.attr('href') + '"\n\t\t\t\t\t\t\t\tclass="' + $parent_link.attr('class') + '">\n\t\t\t\t\t\t\t\t' + $parent_link.text() + '\n\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t</li>');
						}

						// center dropdown menu
						// const parent_width = $menu.closest('li').innerWidth()
						// const menu_width = $menu.outerWidth()
						// const menu_padding = 20
						// const pull = `${(-menu_width / 2) + (parent_width / 2) - menu_padding}px`
						// $menu.css({
						// 	width: menu_width + menu_padding * 2,
						// 	left: pull
						// })

						// disable tertiary dropdowns
						var $dropdown = $menu.find('.dropdown');
						$dropdown.find('.dropdown-menu').remove();
						$dropdown.find('.dropdown-toggle').removeClass('dropdown-toggle').removeAttr('data-toggle');
						$dropdown.removeClass('dropdown').removeClass('menu-item-has-children');
					}
				}
			}
		}
	}, {
		key: 'hideOpenSiblingMenus',
		value: function hideOpenSiblingMenus() {
			var collapsibles = $(this.menu_id).find('[data-target^="#collapseID-"]');
			var _iteratorNormalCompletion2 = true;
			var _didIteratorError2 = false;
			var _iteratorError2 = undefined;

			try {
				for (var _iterator2 = collapsibles[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
					var collapsible = _step2.value;

					$(collapsible).on('click', function () {
						$(this).closest('ul').find('[id^="collapseID-"]').collapse('hide');
					});
				}
			} catch (err) {
				_didIteratorError2 = true;
				_iteratorError2 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion2 && _iterator2.return) {
						_iterator2.return();
					}
				} finally {
					if (_didIteratorError2) {
						throw _iteratorError2;
					}
				}
			}
		}
	}]);

	return Nav;
}();